<template>
  <div class="container_export">
    <portal-target name="portal-filter-second_popup" />
    <div class="header">
      <div class="header-right">
        <div class="header-icon">
          <svg-sprite
            :color="'#00564C'"
            :name="'export'"
          />
        </div>
        <div
          v-once
          class="header-title"
          v-html="locales('export_header_title')"
        />
      </div>
      <div class="header-close">
        <icon-button
          :icon="{ name:'close-1' }"
          size="small"
          @onClick="closeExport"
        />
      </div>
    </div>
    <div class="body">
      <div :class="['gantt', isRightBarShown ? '' : 'gantt_expanded' ]">
        <gantt-view
          v-show="showFrame"
          @ready="initGanttInstance"
        />
        <paper-with-svg
          v-show="!showFrame"
          :export-type="'xml'"
        />
      </div>
      <div
        v-if="isGanttInstanceLoaded"
        v-show="isRightBarShown"
        :class="['right-bar export-right-bar', !isRightBarShown ? 'collapsed' : '', filterIsOpen ? 'filter-open' : '']"
      >
        <right-bar
          :gantt-config="ganttInstance.config"
          :is-multiview="!!ganttInstance.config.multiview"
          :zoom="zoom"
          @onChangeFilterState="handleChangeFilterState"
          @onBaselineDisable="handleDisableBaseline"
          @onBaselineEnable="handleEnableBaseline"
          @onChangeOption="handleConfigOptionChange"
          @onChangeVisibility="handleColumnVisibilityChange"
          @onChangeZoom="handleZoomChange"
          @onExport="handleExport"
          @toggleSidebar="rightBarToggle"
          @filterClick="toggleFilter"
          @showXMLStub="value => showFrame = !value"
        />

        <!-- todo: fix new gantt -->
        <!-- <LayoutHeaderRightBar
          v-bind:title="layoutTitle"
          v-bind:key="layoutTitle"
          v-bind:iframe="GanttIframe"
          v-bind:paperWithSvg="PaperWithSvg"
          v-bind:rightBar="RightBar"
          v-bind:appFilter="appFilter"
        > -->
      </div>
      <div
        v-if="!isRightBarShown"
        class="export_expand_button"
      >
        <icon-button
          :icon="{ name:'collaps-2', size: 24, type: 'bold' }"
          :colors="iconColors"
          :size="'middle'"
          :label="locales('export_expand_settings')"
          @onClick="rightBarToggle"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import projectsModel from '$$projectModel';
import ganttViewConstructor from '../ganttView/init';
import constants from '$$helpers/constants';
import minimizeIcon from '../../svg/history/historylist_minimize.svg';
import GanttView from '../ganttView/ganttView.vue';
import RightBar from './rightBar/RightBar.vue';
import routerHelper from '$$routerHelper';
import iconButton from '../common/VueComponents/globalButton/withIcon/iconButton.vue';
import PaperWithSvg from './PaperWithSvg.vue';
import GanttExporter from './GanttExporter';
// import LayoutHeaderRightBar from './layout-with-header-and-right-bar/LayoutHeaderRightBar.vue';
// import GanttIframe from './GanttIframe.vue';
// import appFilter from '../filterOld/filter.vue';

const __ = window.__;

export default {
  name: 'Export',
  components: {
    PaperWithSvg,
    iconButton,
    RightBar,
    GanttView,
  },
  data() {
    return {
      locales: __,
      isGanttInstanceLoaded: false,
      isRightBarShown: true,
      showFrame: true,
      layoutTitle: __('export_header_title'),
      minimizeIcon: `<div class="header-hide-bar-icon">${minimizeIcon}</div>`,
      colors: {
        color: '#333333',
      },
      iconColors: {
        color: '#1565C0',
        labelColor: '#1565C0',
        activeColor: '#11519A',
        hoverBg: '#D0E0F2',
        activeBg: '#A1C1E6',
        activeHoverBg: '#D0E0F2',
        bg: '#D0E0F2',
      },
      zoom: this.$store.getters['headerView/zoom'],
    };
  },
  computed: {
    customColumnsValuesLoaded() {
      return this.$store.getters['columns/valuesLoaded'];
    },
    filterIsOpen() {
      return this.$store.getters['filter/isOpen'];
    },

  },
  watch: {
    customColumnsValuesLoaded(loaded) {
      if (loaded) {
        this.ganttInstance.callEvent('export:onCustomColumnsValuesLoaded');
      }
    },
  },
  beforeCreate() {
    if (this.$route.params.projectId) {
      projectsModel.setActiveProject(+this.$route.params.projectId, false, true);
    }
    this.$store.commit('setAppMode', constants.APP_MODES.EXPORT);
  },
  created() {
    this.ganttInstance = null;
    this.hideLeftSideBarAndFooter();
  },
  mounted() {
    userExtAnalytics.log('project_export_open');
  },
  methods: {
    hideLeftSideBarAndFooter() {
      const leftSideBar = $$('leftSideBar');
      const footer = $$('footer');

      leftSideBar.$view.classList.add('left_sidebar_down_index');
      footer.$view.classList.add('footer_down_index');
    },
    initGanttInstance() {
      if (this.$route.params.multiviewID) {
        this.ganttInstance = ganttViewConstructor.initGanttInstanceExportMultiview(+this.$route.params.multiviewID);
      } else {
        this.ganttInstance = ganttViewConstructor.initGanttInstanceExport(+this.$route.params.projectId);
      }

      this.ganttInstance.attachEvent('export:workloadResetZoom', value => {
        this.handleZoomChange(value);
      });

      setTimeout(() => {// need for full set up gantt config
        this.isGanttInstanceLoaded = true;
      });
    },
    closeExport() {
      const routerName = this.ganttInstance.config.multiview
        ? 'projectsMultiView'
        : 'project';

      this.$store.commit('setAppMode', constants.APP_MODES.BASE);
      this.$router.push({
        name: routerName,
        params: { ...this.$route.params, mode: 'gantt' },
      });
    },
    rightBarToggle() {
      if (!this.isRightBarShown) {
        this.userAnalyticsOpenCloseFilter('filter_close');
      } else {
        this.userAnalyticsOpenCloseFilter('filter_open');
      }

      if (this.filterIsOpen) {
        this.toggleFilter();
      }

      this.isRightBarShown = !this.isRightBarShown;
    },
    userAnalyticsOpenCloseFilter(event_name) {
      let from = '';
      let route = '';

      const url = routerHelper.getCurrentRoute().path;
      const urlArr = url.slice(1).split('/');
      const urlItems = urlArr.filter(item => !parseInt(item, 10));

      switch (urlItems[0]) {
      case 'project':
        from = 'project & portfolio';
        route = 'Project/export';
        break;
      case 'projects':
        from = 'project & portfolio';
        route = 'Portfolio/export';
        break;
      default:
        from = urlItems[0];
        route = url;
      }

      userExtAnalytics.log(event_name, { from, route });
    },
    handleChangeFilterState() {
      this.ganttInstance.callEvent('export:onChangeFilterState');
    },
    handleDisableBaseline(id) {
      this.ganttInstance.callEvent('export:onBaselineDisable', [id]);
    },
    handleEnableBaseline(id) {
      this.ganttInstance.callEvent('export:onBaselineEnable', [id]);
    },
    handleConfigOptionChange(option) {
      this.ganttInstance.callEvent('export:onConfigOptionChange', [option]);
    },
    handleColumnVisibilityChange(column) {
      this.ganttInstance.callEvent('export:onColumnVisibilityChange', [column]);
    },
    handleZoomChange: _.debounce(function (value) {
      this.zoom = value;
      this.ganttInstance.callEvent('export:onZoomChange', [constants.ZOOM.zoomValueToMode[value]]);
    }, 300),
    handleExport({ exportType, exportSettings }) {
      const exporter = new GanttExporter(
        this.ganttInstance,
        {
          exportType,
          exportSettings,
        },
      );

      exporter.export();
    },
    toggleFilter() {
      const toggle = !this.filterIsOpen;

      setTimeout(() => {
        this.$store.commit('filter/toggleFilter', toggle);
      }, 0);
    },
  },
};
</script>

<style src="./style.less" scoped></style>
